import { Logger } from "../lib/logging"

export const ROOT_ROUTE = "/"

// --- Common sub routes ---
export const ADMIN_SUB_ROUTE = "admin"
export const REPORT_SUB_ROUTE = "reports"
export const ACCOUNTING_SUB_ROUTE = "accounting"
export const PROFILE_SUB_ROUTE = "profile"
export const PROFILE_CHANGE_PASSWORD_SUB_ROUTE = `${PROFILE_SUB_ROUTE}/change-password`
export const SETTINGS_SUB_ROUTE = "settings"
export const NEWS_SUB_ROUTE = "facilitynet-news"
export const ORGANIZATION_SUB_ROUTE = "organization"

// --- Login ---
export const LOGIN_ROUTE = "/login"
export const USER_NAME_ROUTE = `${LOGIN_ROUTE}/username`
export const AUTH_PASSWORD_ROUTE = `${LOGIN_ROUTE}/password`
export const FORGOT_PASSWORD_ROUTE = `${LOGIN_ROUTE}/forgot-password`
export const ACTIVATION_CODE_ROUTE = `${LOGIN_ROUTE}/activation-code`
export const CREATE_PASSWORD_ROUTE = `${LOGIN_ROUTE}/create-password`
export const ID_CARD_SIGNUP_ROUTE = `${LOGIN_ROUTE}/id-card-signup`
export const INVITATION_ROUTE = `${LOGIN_ROUTE}/invitation`
export const CONFIRM_ACCOUNT_CHANGE_ROUTE = `${LOGIN_ROUTE}/confirm-account-change`
export const SIGN_IN_WITH_OTP_ROUTE = `${LOGIN_ROUTE}/otp`

// --- Activate account ---
export const ACTIVATE_ACCOUNT_ROUTE = `/activate-account`
export const ACTIVATE_ACCOUNT_ACTIVATION_CODE_ROUTE = `${ACTIVATE_ACCOUNT_ROUTE}/activation-code`
export const ACTIVATE_ACCOUNT_CREATE_PASSWORD_ROUTE = `${ACTIVATE_ACCOUNT_ROUTE}/create-password`
export const ACTIVATE_ACCOUNT_SELECT_COMPANY_ROUTE = `${ACTIVATE_ACCOUNT_ROUTE}/select-company`

export const ACTIVATE_ACCOUNT_DA_ROUTE = `/aktiver-konto`
export const ACTIVATE_ACCOUNT_ACTIVATION_CODE_DA_ROUTE = `${ACTIVATE_ACCOUNT_DA_ROUTE}/activation-code`
export const ACTIVATE_ACCOUNT_CREATE_PASSWORD_DA_ROUTE = `${ACTIVATE_ACCOUNT_DA_ROUTE}/create-password`
export const ACTIVATE_ACCOUNT_SELECT_COMPANY_DA_ROUTE = `${ACTIVATE_ACCOUNT_DA_ROUTE}/select-company`

// --- Public ---
export const PUBLIC_ROUTE = "/public"
export const CONFIRM_BOOKING_PUBLIC_ROUTE = `${PUBLIC_ROUTE}/confirm-booking`
export const PUBLIC_SELF_SIGN_UP_EN = `/new-user/:systemId`
export const PUBLIC_SELF_SIGN_UP_DA = `/ny-bruger/:systemId`
export const PUBLIC_MEETING_ORDER_RECEIPT = `${PUBLIC_ROUTE}/orders/meetings/:orderUid`
export const PUBLIC_ORDER_RECEIPT = `${PUBLIC_ROUTE}/orders/:orderUid`
export const PUBLIC_PACKAGE_SLIP_RECEIPT = `${PUBLIC_ROUTE}/meeting-service/package-slip/:slipUid`
export const PUBLIC_ROADMAP_SHARE_ROUTE = `${PUBLIC_ROUTE}/share/:shareToken`

// --- Confirm account email ---
export const ME_ROUTE = "/me"
export const CONFIRM_ACCOUNT_EMAIL_ROUTE = `${ME_ROUTE}/confirm-email`

// --- Views ---
export const VIEWS_ROUTE = "/views"
export const VIEWS_MERCHANT_ROUTE = `${VIEWS_ROUTE}/merchant`
export const VIEWS_MERCHANT_CONFERENCE_ROUTE = `${VIEWS_MERCHANT_ROUTE}/conference`

// --- Create / Update order ---
export const ORDER_ROUTE = "/order"

// --- Office Manager ---

export const OFFICE_MANAGER_ROUTE = "/office"
export const OFFICE_MANAGER_NEWS_ROUTE = `${OFFICE_MANAGER_ROUTE}/${NEWS_SUB_ROUTE}`

//admin
export const TENANT_ADMIN_ROUTE = `${OFFICE_MANAGER_ROUTE}/admin`
export const TENANT_ADMIN_ORGANIZATION_ROUTE = `${TENANT_ADMIN_ROUTE}/organization`
export const TENANT_USERS_ROUTE = `${TENANT_ADMIN_ORGANIZATION_ROUTE}/users`
export const TENANT_USERS_CREATE_USER_ROUTE = `${TENANT_USERS_ROUTE}/create-user`
export const TENANT_USERS_CREATE_ADMIN_ROUTE = `${TENANT_USERS_ROUTE}/create-admin`

//reports
export const TENANT_REPORTS_ROUTE = `${OFFICE_MANAGER_ROUTE}/reports`
export const TENANT_ACCOUNTING_ROUTE = `${TENANT_REPORTS_ROUTE}/accounting`
export const TENANT_ACCOUNTING_POS_ROUTE = `${TENANT_ACCOUNTING_ROUTE}/pos`
export const TENANT_ACCOUNTING_MEETING_SERVICE_ROUTE = `${TENANT_ACCOUNTING_ROUTE}/meeting-service`
export const TENANT_ACCOUNTING_SUBSCRIPTIONS_ROUTE = `${TENANT_ACCOUNTING_ROUTE}/subscriptions`

// --- Merchant ---

export const MERCHANT_ROUTE = "/merchant"
export const MERCHANT_GOPAY_NEWS_ROUTE = `${MERCHANT_ROUTE}/${NEWS_SUB_ROUTE}`

// Reports
export const MERCHANT_REPORTS_ROUTE = `${MERCHANT_ROUTE}/${REPORT_SUB_ROUTE}`
export const MERCHANT_PRODUCTION_ROUTE = `${MERCHANT_REPORTS_ROUTE}/production`
export const MERCHANT_PRODUCTION_PLANNING_ROUTE = `${MERCHANT_PRODUCTION_ROUTE}/planning`
export const MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE = `${MERCHANT_PRODUCTION_ROUTE}/meeting-service`
export const MERCHANT_PRODUCTION_POS_PURCHASES_ROUTE = `${MERCHANT_PRODUCTION_ROUTE}/pos-purchases`
export const MERCHANT_PRODUCTION_TAKEAWAY_ROUTE = `${MERCHANT_PRODUCTION_ROUTE}/takeaway`
export const CONTROL_KITCHEN_ROUTE = `${MERCHANT_REPORTS_ROUTE}/control-kitchen`
export const MERCHANT_REPORTS_MENU_PLANNING_ROUTE = `${MERCHANT_REPORTS_ROUTE}/menu-planning`
export const SURVEY_ROUTE = `${MERCHANT_REPORTS_ROUTE}/survey`
export const ROLLUP_GRAPH_EXAMPLE_ROUTE = `${MERCHANT_REPORTS_ROUTE}/rollup-graph-example`

// Accounting
export const MERCHANT_ACCOUNTING_ROUTE = `${MERCHANT_ROUTE}/${ACCOUNTING_SUB_ROUTE}`
export const MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE = `${MERCHANT_ACCOUNTING_ROUTE}/accounting`
export const MERCHANT_ACCOUNTING_PRODUCT_SALES = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/product-sales`
export const MERCHANT_ACCOUNTING_ORDERS = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/orders`
export const MERCHANT_ACCOUNTING_SUBSCRIPTIONS = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/subscriptions`
export const MERCHANT_ACCOUNTING_CASH_REGISTER = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/cash-register`
export const MERCHANT_ACCOUNTING_CUSTOMERS = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/customers`
export const MERCHANT_ACCOUNTING_CUSTOMER_BALANCE = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/customer-balance`
export const MERCHANT_ACCOUNTING_Z_REPORT = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/z-report`
export const MERCHANT_CUSTOM_REPORTS_ROUTE = `${MERCHANT_ACCOUNTING_ACCOUNTING_ROUTE}/custom-reports`

// Admin
export const MERCHANT_ADMIN_ROUTE = `${MERCHANT_ROUTE}/${ADMIN_SUB_ROUTE}`

// - Communication -
export const MERCHANT_ADMIN_COMMUNICATION_ROUTE = `${MERCHANT_ADMIN_ROUTE}/communication`
// News
export const MERCHANT_NEWS_ROUTE = `${MERCHANT_ADMIN_COMMUNICATION_ROUTE}/news`
export const MERCHANT_NEWS_CREATE_NEWS_ITEM_ROUTE = `${MERCHANT_NEWS_ROUTE}/create`
export const MERCHANT_NEWS_EDIT_NEWS_ITEM_ROUTE = `${MERCHANT_NEWS_ROUTE}/edit/:articleId`
// Surveys
export const MERCHANT_ADMIN_SURVEYS = `${MERCHANT_ADMIN_COMMUNICATION_ROUTE}/surveys`
export const MERCHANT_ADMIN_CREATE_SURVEY_ITEM = `${MERCHANT_ADMIN_SURVEYS}/create`
export const MERCHANT_ADMIN_EDIT_SURVEY_ITEM_ROUTE = `${MERCHANT_ADMIN_SURVEYS}/edit/:surveyId`
// Message
export const MESSAGES_ROUTE = `${MERCHANT_ADMIN_COMMUNICATION_ROUTE}/messages`
export const MESSAGES_ROUTE_CREATE_MESSAGE_ITEM = `${MESSAGES_ROUTE}/create`
export const MESSAGES_ROUTE_EDIT_MESSAGE_ITEM = `${MESSAGES_ROUTE}/edit/:messageId`

export const MERCHANT_ADMIN_ACCOUNT_ROUTE = `${MERCHANT_ADMIN_ROUTE}/account`
export const MERCHANT_ADMIN_USERS_ROUTE = `${MERCHANT_ADMIN_ACCOUNT_ROUTE}/users`
export const MERCHANT_ADMIN_CREATE_ROUTE = `${MERCHANT_ADMIN_USERS_ROUTE}/create`
export const MERCHANT_ADMIN_MERCHANT_ACCOUNT_ROUTE = `${MERCHANT_ADMIN_ACCOUNT_ROUTE}/merchant-account`

// Shops
export const MERCHANT_ADMIN_SHOPS_ROUTE = `${MERCHANT_ADMIN_ROUTE}/shops`
export const MERCHANT_ADMIN_SHOPS_LIST_ROUTE = `${MERCHANT_ADMIN_SHOPS_ROUTE}/shops-list`
export const MERCHANT_ADMIN_SHOPS_LIST_CREATE_ROUTE = `${MERCHANT_ADMIN_SHOPS_LIST_ROUTE}/create`
export const MERCHANT_ADMIN_SHOPS_LIST_EDIT_ROUTE = `${MERCHANT_ADMIN_SHOPS_LIST_ROUTE}/edit/:shopId`
export const MERCHANT_ADMIN_SHOPS_CUSTOMER_ACCESS_ROUTE = `${MERCHANT_ADMIN_SHOPS_ROUTE}/customer-access`
export const MERCHANT_ADMIN_ROUTE_DEVICES = `${MERCHANT_ADMIN_SHOPS_ROUTE}/devices`
export const MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE = `${MERCHANT_ADMIN_SHOPS_ROUTE}/payment-links`
export const MERCHANT_ADMIN_PAYMENT_LINK_CREATE_ROUTE = `${MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE}/create`
export const MERCHANT_ADMIN_PAYMENT_LINK_EDIT_ROUTE = `${MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE}/edit/:paymentLinksId`

// Products
export const MERCHANT_ADMIN_PRODUCTS_ROUTE = `${MERCHANT_ADMIN_ROUTE}/products`
export const MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_ROUTE}/products-list`
export const MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_ROUTE}/extra-services`
export const MERCHANT_ADMIN_EXTRA_SERVICES_CREATE_ROUTE = `${MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE}/create`
export const MERCHANT_ADMIN_EXTRA_SERVICES_EDIT_ROUTE = `${MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE}/edit/:extraServiceId`
export const MERCHANT_ADMIN_PRODUCTS_CREATE_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE}/create`
export const MERCHANT_ADMIN_PRODUCTS_EDIT_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE}/edit/:productId`
export const MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_ROUTE}/product-groups`
export const MERCHANT_ADMIN_PRODUCTS_GROUP_CREATE_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE}/create`
export const MERCHANT_ADMIN_PRODUCTS_GROUP_UPDATE_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE}/:productGroupId`
export const MERCHANT_ADMIN_OFFERS_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_ROUTE}/offers`
export const MERCHANT_ADMIN_PRICE_LISTS_ROUTE = `${MERCHANT_ADMIN_PRODUCTS_ROUTE}/price-lists`
export const MERCHANT_ADMIN_CREATE_PRICE_LIST_ROUTE = `${MERCHANT_ADMIN_PRICE_LISTS_ROUTE}/create`
export const MERCHANT_ADMIN_UPDATE_PRICE_LIST_ROUTE = `${MERCHANT_ADMIN_PRICE_LISTS_ROUTE}/:priceListId`

// --- Merchant Settings ---
export const MERCHANT_ADMIN_SETTINGS_ROUTE = `${MERCHANT_ADMIN_ROUTE}/settings`
export const MERCHANT_ADMIN_SETTINGS_ID_CARDS_ROUTE = `${MERCHANT_ADMIN_SETTINGS_ROUTE}/id-cards`
export const MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE = `${MERCHANT_ADMIN_SETTINGS_ROUTE}/vat-codes`
export const MERCHANT_ADMIN_SETTINGS_CREATE_VAT_CODES_ROUTE = `${MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE}/create`
export const MERCHANT_ADMIN_SETTINGS_UPDATE_VAT_CODES_ROUTE = `${MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE}/:vatCodeId`
export const MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE = `${MERCHANT_ADMIN_SETTINGS_ROUTE}/delivery-locations`
export const MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATION_CREATE_ROUTE = `${MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE}/create`
export const MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATION_UPDATE_ROUTE = `${MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE}/:deliveryLocationId`
export const MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE = `${MERCHANT_ADMIN_SETTINGS_ROUTE}/sales-accounts`
export const MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_CREATE_ROUTE = `${MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE}/create`
export const MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNT_UPDATE_ROUTE = `${MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE}/edit/:salesAccountId`
export const MERCHANT_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE = `${MERCHANT_ADMIN_SETTINGS_ROUTE}/custom-jobs`

// --- Supplier ---

export const SUPPLIER_ROUTE = "/supplier"
export const SUPPLIER_NEWS_ROUTE = `${SUPPLIER_ROUTE}/${NEWS_SUB_ROUTE}`

// Reports
export const SUPPLIER_REPORTS_ROUTE = `${SUPPLIER_ROUTE}/${REPORT_SUB_ROUTE}`
export const SUPPLIER_REPORTS_MERCHANTS_ROUTE = `${SUPPLIER_REPORTS_ROUTE}/merchants`
export const SUPPLIER_REPORTS_ACCOUNTING_ROUTE = `${SUPPLIER_REPORTS_ROUTE}/accounting`
export const SUPPLIER_REPORTS_ACCOUNTING_POS_ROUTE = `${SUPPLIER_REPORTS_ACCOUNTING_ROUTE}/pos`
export const SUPPLIER_REPORTS_ACCOUNTING_MEETING_SERVICE_ROUTE = `${SUPPLIER_REPORTS_ACCOUNTING_ROUTE}/meeting-service`
export const SUPPLIER_REPORTS_ACCOUNTING_SUBSCRIPTIONS_ROUTE = `${SUPPLIER_REPORTS_ACCOUNTING_ROUTE}/subscriptions`
export const SUPPLIER_REPORTS_ACCOUNTING_MERCHANT_SALES_ROUTE = `${SUPPLIER_REPORTS_ACCOUNTING_ROUTE}/merchant-sales`
export const SUPPLIER_REPORTS_ACCOUNTING_CUSTOMER_SALES_ROUTE = `${SUPPLIER_REPORTS_ACCOUNTING_ROUTE}/customer-sales`
export const SUPPLIER_REPORTS_ACCOUNTING_Z_REPORTS_ROUTE = `${SUPPLIER_REPORTS_ACCOUNTING_ROUTE}/z-reports`

// Admin
export const SUPPLIER_ADMIN_ROUTE = `${SUPPLIER_ROUTE}/${ADMIN_SUB_ROUTE}`
export const SUPPLIER_ADMIN_MERCHANTS_ROUTE = `${SUPPLIER_ADMIN_ROUTE}/merchants`
export const SUPPLIER_ADMIN_SETTINGS_ROUTE = `${SUPPLIER_ADMIN_ROUTE}/settings`
export const SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE = `${SUPPLIER_ADMIN_MERCHANTS_ROUTE}/merchants-list`
export const SUPPLIER_ADMIN_MERCHANTS_CREATE_ROUTE = `${SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE}/create`
export const SUPPLIER_ADMIN_MERCHANTS_EDIT_ROUTE = `${SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE}/edit/:merchantId`
export const SUPPLIER_ADMIN_DEVICES_ROUTE = `${SUPPLIER_ADMIN_MERCHANTS_ROUTE}/devices`
export const SUPPLIER_ADMIN_MERCHANT_ADMINISTRATORS_ROUTE = `${SUPPLIER_ADMIN_MERCHANTS_ROUTE}/administrators`
export const SUPPLIER_ADMIN_ACQUIRING_ROUTE = `${SUPPLIER_ADMIN_SETTINGS_ROUTE}/acquiring`
export const SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE = `${SUPPLIER_ADMIN_SETTINGS_ROUTE}/terms-and-conditions`
export const SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_CREATE_ROUTE = `${SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE}/create`
export const SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_EDIT_ROUTE = `${SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE}/edit/:termsAndConditionsId`
export const SUPPLIER_ADMIN_ACCOUNT_ROUTE = `${SUPPLIER_ADMIN_ROUTE}/account`
export const SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE = `${SUPPLIER_ADMIN_ACCOUNT_ROUTE}/administrators`
export const SUPPLIER_ADMIN_ADMINISTRATORS_CREATE_ROUTE = `${SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE}/create`
export const SUPPLIER_ADMIN_ACCOUNT_COMPANY_ROUTE = `${SUPPLIER_ADMIN_ACCOUNT_ROUTE}/company`
export const SUPPLIER_ADMIN_ACCOUNT_GDPR_ROUTE = `${SUPPLIER_ADMIN_ACCOUNT_ROUTE}/gdpr`
export const SUPPLIER_ADMIN_POS_SETTINGS_ROUTE = `${SUPPLIER_ADMIN_SETTINGS_ROUTE}/pos-settings`
export const SUPPLIER_ADMIN_POS_SETTINGS_CREATE_TEMPLATE_ROUTE = `${SUPPLIER_ADMIN_POS_SETTINGS_ROUTE}/templates/create`
export const SUPPLIER_ADMIN_POS_SETTINGS_EDIT_TEMPLATE_ROUTE = `${SUPPLIER_ADMIN_POS_SETTINGS_ROUTE}/templates/edit/:templateId`
export const SUPPLIER_ADMIN_ERP_ROUTE = `${SUPPLIER_ADMIN_ROUTE}/erp`
export const SUPPLIER_ADMIN_ACQUIRING_REPORTS_ROUTE = `${SUPPLIER_ADMIN_ROUTE}/acquiring-reports`
export const SUPPLIER_ADMIN_ACQUIRING_REPORTS_BALANCE_ROUTE = `${SUPPLIER_ADMIN_ACQUIRING_REPORTS_ROUTE}/balance`
export const SUPPLIER_ADMIN_ACQUIRING_REPORTS_ACQUIRING_FEES_ROUTE = `${SUPPLIER_ADMIN_ACQUIRING_REPORTS_ROUTE}/acquiring-fees`
export const SUPPLIER_ADMIN_ACQUIRING_REPORTS_BANK_TRANSFERS_ROUTE = `${SUPPLIER_ADMIN_ACQUIRING_REPORTS_ROUTE}/bank-transfers`
export const SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE = `${SUPPLIER_ADMIN_ERP_ROUTE}/product-numbers`
export const SUPPLIER_ADMIN_CREATE_PRODUCT_NUMBERS_ROUTE = `${SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE}/create`
export const SUPPLIER_ADMIN_UPDATE_PRODUCT_NUMBERS_ROUTE = `${SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE}/:productGroupsNumbersId`

// --- Support ---

export const SUPPORT_ROUTE = "/support"

// Reports
export const SUPPORT_REPORTS_ROUTE = `${SUPPORT_ROUTE}/${REPORT_SUB_ROUTE}`
export const SUPPORT_REPORTS_SUPPLIERS_ROUTE = `${SUPPORT_REPORTS_ROUTE}/suppliers`
export const SUPPORT_REPORTS_MERCHANTS_ROUTE = `${SUPPORT_REPORTS_ROUTE}/merchants`
export const SUPPORT_REPORTS_ENTITIES_ROUTE = `${SUPPORT_REPORTS_ROUTE}/entities`
export const SUPPORT_REPORTS_ROUTE_DEVICES = `${SUPPORT_REPORTS_ROUTE}/devices`
export const SUPPORT_REPORTS_MESSAGES_ROUTE = `${SUPPORT_REPORTS_ROUTE}/messages`
export const SUPPORT_REPORTS_MESSAGES_EMAIL_ROUTE = `${SUPPORT_REPORTS_MESSAGES_ROUTE}/email`
export const SUPPORT_REPORTS_MESSAGES_SMS_ROUTE = `${SUPPORT_REPORTS_MESSAGES_ROUTE}/sms`
export const SUPPORT_REPORTS_PRINTER_QUEUE = `${SUPPORT_REPORTS_ROUTE}/printer-queue`
export const SUPPORT_REPORTS_ROUTE_ORDERS_ROUTE = `${SUPPORT_REPORTS_ROUTE}/orders`
export const SUPPORT_REPORTS_ROUTE_ORDERS_POS_ROUTE = `${SUPPORT_REPORTS_ROUTE_ORDERS_ROUTE}/pos`
// export const SUPPORT_REPORTS_ROUTE_ACCOUNTING_ROUTE = `${SUPPORT_REPORTS_ROUTE}/accounting`
export const SUPPORT_REPORTS_ROUTE_ORDERS_SUBSCRIPTIONS_ROUTE = `${SUPPORT_REPORTS_ROUTE_ORDERS_ROUTE}/subscriptions`
export const SUPPORT_REPORTS_ROUTE_ORDERS_MEETING_SERVICE_ROUTE = `${SUPPORT_REPORTS_ROUTE_ORDERS_ROUTE}/meeting-service`

// Admin

export const SUPPORT_ADMIN_ROUTE = `${SUPPORT_ROUTE}/${ADMIN_SUB_ROUTE}`
export const SUPPORT_ENTITIES_ROUTE = `${SUPPORT_ADMIN_ROUTE}/entities`
export const SUPPORT_FEATURES_ROUTE = `${SUPPORT_ADMIN_ROUTE}/features`
export const SUPPORT_FEATURES_EDIT_ROUTE = `${SUPPORT_FEATURES_ROUTE}/:featureId`
export const SUPPORT_ENTITIES_COMPANY_ROUTE = `${SUPPORT_ENTITIES_ROUTE}/company`
export const SUPPORT_ENTITIES_SUPPLIER_ROUTE = `${SUPPORT_ENTITIES_ROUTE}/supplier`
export const SUPPORT_ENTITIES_CREATE_COMPANY_ROUTE = `${SUPPORT_ENTITIES_COMPANY_ROUTE}/create`
export const SUPPORT_ENTITIES_UPDATE_COMPANY_ROUTE = `${SUPPORT_ENTITIES_COMPANY_ROUTE}/:entityId`
export const SUPPORT_ENTITIES_CREATE_SUPPLIER_ROUTE = `${SUPPORT_ENTITIES_SUPPLIER_ROUTE}/create`
export const SUPPORT_ENTITIES_UPDATE_SUPPLIER_ROUTE = `${SUPPORT_ENTITIES_SUPPLIER_ROUTE}/:entityId`
export const SUPPORT_ADMIN_INVOICING_ROUTE = `${SUPPORT_ADMIN_ROUTE}/invoicing`
export const SUPPORT_ADMIN_INVOICING_BASIS_FOR_INVOICING_ROUTE = `${SUPPORT_ADMIN_INVOICING_ROUTE}/basis-for-invoicing`
export const SUPPORT_ADMIN_HEALTH_ROUTE = `${SUPPORT_ADMIN_ROUTE}/health`
export const SUPPORT_ADMIN_HEALTH_DATABASE_HEALTH_ROUTE = `${SUPPORT_ADMIN_HEALTH_ROUTE}/database-health`
export const SUPPORT_ADMIN_HEALTH_SCHEDULER_ROUTE = `${SUPPORT_ADMIN_HEALTH_ROUTE}/scheduler`
export const SUPPORT_ADMIN_HEALTH_SCHEDULER_EDIT_ROUTE = `${SUPPORT_ADMIN_HEALTH_SCHEDULER_ROUTE}/edit/:jobId`
export const SUPPORT_ADMIN_HEALTH_SERVER_MEMORY_ROUTE = `${SUPPORT_ADMIN_HEALTH_ROUTE}/server-memory`
export const SUPPORT_ADMIN_HEALTH_ADYEN_ROUTE = `${SUPPORT_ADMIN_HEALTH_ROUTE}/adyen`
export const SUPPORT_ADMIN_GDPR_ROUTE = `${SUPPORT_ADMIN_ROUTE}/gdpr`

// --- Company ---

export const COMPANY_ROUTE = "/company"
export const COMPANY_REPORTS_ROUTE = `${COMPANY_ROUTE}/${REPORT_SUB_ROUTE}`
export const COMPANY_ACCOUNTING_ROUTE = `${COMPANY_REPORTS_ROUTE}/accounting`
export const COMPANY_ACCOUNTING_POS_ROUTE = `${COMPANY_ACCOUNTING_ROUTE}/pos`
export const COMPANY_ACCOUNTING_MEETING_SERVICE_ROUTE = `${COMPANY_ACCOUNTING_ROUTE}/meeting-service`
export const COMPANY_ACCOUNTING_SUBSCRIPTIONS_ROUTE = `${COMPANY_ACCOUNTING_ROUTE}/subscriptions`
export const COMPANY_ADMIN_ROUTE = `${COMPANY_ROUTE}/${ADMIN_SUB_ROUTE}`
export const COMPANY_REPORTS_ACCOUNTING_ROUTE = `${COMPANY_REPORTS_ROUTE}/accounting`
export const COMPANY_ADMIN_ACCOUNTING_ROUTE = `${COMPANY_ADMIN_ROUTE}/accounting`
export const COMPANY_ADMIN_ACCOUNTING_BILL_RECEIVERS_ROUTE = `${COMPANY_ADMIN_ACCOUNTING_ROUTE}/bill-receivers`
export const COMPANY_ADMIN_ACCOUNT_ROUTE = `${COMPANY_ADMIN_ROUTE}/account`
export const COMPANY_ADMIN_ACCOUNT_GDPR_ROUTE = `${COMPANY_ADMIN_ACCOUNT_ROUTE}/gdpr`
export const COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE = `${COMPANY_ADMIN_ACCOUNT_ROUTE}/administrators`
export const COMPANY_ADMIN_DATA_IMPORT_ROUTE = `${COMPANY_ADMIN_ROUTE}/data-import`
export const COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_ROUTE}/id-cards`
export const COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_RESULT_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_ROUTE}/result`
export const COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_ROUTE}/account-numbers`
export const COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_RESULT_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_ACCOUNT_NUMBERS_ROUTE}/result`
export const COMPANY_ADMIN_DATA_IMPORT_USERS_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_ROUTE}/users`
export const COMPANY_ADMIN_DATA_IMPORT_USERS_RESULT_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_USERS_ROUTE}/result`
export const COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_ROUTE}/bill-receivers`
export const COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_RESULT_ROUTE = `${COMPANY_ADMIN_DATA_IMPORT_BILL_RECEIVERS_ROUTE}/result`
export const COMPANY_ADMIN_SETTINGS_ROUTE = `${COMPANY_ADMIN_ROUTE}/settings`
export const COMPANY_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE = `${COMPANY_ADMIN_SETTINGS_ROUTE}/custom-jobs`

export const COMPANY_ADMIN_ORGANIZATION_ROUTE = `${COMPANY_ADMIN_ROUTE}/organization`
export const COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_ROUTE}/locations`
export const COMPANY_ADMIN_ORGANIZATION_LOCATIONS_CREATE_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE}/create`
export const COMPANY_ADMIN_ORGANIZATION_LOCATIONS_EDIT_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE}/edit/:locationId`
export const COMPANY_ADMIN_ORGANIZATION_USERS_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_ROUTE}/users`
export const COMPANY_ADMIN_ORGANIZATION_USERS_CREATE_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_ROUTE}/create-user`
export const COMPANY_ADMIN_ORGANIZATION_ADMINS_CREATE_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_ROUTE}/create-admin`
export const COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_ROUTE}/departments`
export const COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_CREATE_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE}/create`
export const COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_EDIT_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE}/edit/:departmentId`
export const COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_ROUTE}/user-groups`
export const COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_CREATE_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE}/create`
export const COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_EDIT_ROUTE = `${COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE}/edit/:userGroupId`

// --- User ---
export const USER_ROUTE = "/user"

// --- User routes ---
export const USER_REPORTS_ROUTE = `${USER_ROUTE}/${REPORT_SUB_ROUTE}`
export const USER_REPORTS_UPCOMING_ORDERS_ROUTE = `${USER_REPORTS_ROUTE}/upcoming-orders`
export const USER_REPORTS_UPCOMING_ORDERS_PURCHASES_ROUTE = `${USER_REPORTS_UPCOMING_ORDERS_ROUTE}/purchases`
export const USER_REPORTS_ARCHIVE_ROUTE = `${USER_REPORTS_ROUTE}/archive`
export const USER_REPORTS_GOPAY_NEWS_ROUTE = `${USER_REPORTS_ROUTE}/news`
export const USER_REPORTS_SETTINGS_ROUTE = `${USER_REPORTS_ROUTE}/settings`
export const USER_REPORTS_PROFILE_ROUTE = `${USER_REPORTS_ROUTE}/profile`
export const USER_REPORTS_SETTINGS_BILL_RECEIVERS_ROUTE = `${USER_REPORTS_SETTINGS_ROUTE}/bill-receivers`
export const USER_REPORTS_SETTINGS_BILL_RECEIVERS_EDIT_ROUTE = `${USER_REPORTS_SETTINGS_BILL_RECEIVERS_ROUTE}/edit/:billReceiverId`
export const USER_REPORTS_SETTINGS_WALLETS_ROUTE = `${USER_REPORTS_SETTINGS_ROUTE}/wallets`
export const USER_REPORTS_SETTINGS_WALLETS_STATUS_POLL_ROUTE = `${USER_REPORTS_ROUTE}/wallets/poll/:orderUid`
export const USER_REPORTS_SETTINGS_WALLETS_STATUS_FAILED_ROUTE = `${USER_REPORTS_ROUTE}/wallets/failed`
export const USER_REPORTS_SETTINGS_WALLETS_STATUS_SUCCESS_ROUTE = `${USER_REPORTS_ROUTE}/wallets/success`
export const USER_REPORTS_SETTINGS_WALLETS_REFILL_ROUTE = `${USER_REPORTS_SETTINGS_WALLETS_ROUTE}/:acquirerSetupId/refill/:walletId`
export const USER_REPORTS_TAKEAWAY_SUCCESS_ROUTE = `${USER_REPORTS_ROUTE}/takeaway/success`
export const USER_QUICKPAY_FINALIZED_ROUTE = `${USER_REPORTS_ROUTE}/quickpay/finalized/:orderUid`
export const USER_REPORTS_CALENDAR_ROUTE = `${USER_REPORTS_ROUTE}/calendar`

// --- Service center ---
export const SERVICE_CENTER_ROUTE = "/service-center"

// --- Service center report routes ---
export const SERVICE_CENTER_REPORTS_ROUTE = `${SERVICE_CENTER_ROUTE}/${REPORT_SUB_ROUTE}`
export const SERVICE_CENTER_REPORTS_MEETING_SERVICE_ROUTE = `${SERVICE_CENTER_REPORTS_ROUTE}/meeting-service`
export const SERVICE_CENTER_REPORTS_GUESTS_ROUTE = `${SERVICE_CENTER_REPORTS_ROUTE}/guests`
export const SERVICE_CENTER_REPORTS_CALENDAR_ROUTE = `${SERVICE_CENTER_REPORTS_ROUTE}/calendar`
export const SERVICE_CENTER_REPORTS_STATISTICS_ROUTE = `${SERVICE_CENTER_REPORTS_ROUTE}/statistics`
export const SERVICE_CENTER_REPORTS_PROFILE_ROUTE = `${SERVICE_CENTER_REPORTS_ROUTE}/profile`

// --- Service center admin routes ---
export const SERVICE_CENTER_ADMIN_ROUTE = `${SERVICE_CENTER_ROUTE}/${ADMIN_SUB_ROUTE}`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE = `${SERVICE_CENTER_ADMIN_ROUTE}/organization`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE}/resources`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_ROOM_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/room/create`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_MOBILE_AV_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/mobile-av/create`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_CREATE_CARS_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/cars/create`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_ROOM_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/room/:roomId`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_MOBILE_AV_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/mobile-av/:mobileAvId`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_EDIT_CARS_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/cars/:carId`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_MANAGE_BOOKINGS_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE}/manage-bookings`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_ROUTE}/devices`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_CREATE_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE}/create`
export const SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_EDIT_ROUTE = `${SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE}/:deviceId`
export const SERVICE_CENTER_ADMIN_ACCOUNT_ROUTE = `${SERVICE_CENTER_ADMIN_ROUTE}/account`
export const SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE = `${SERVICE_CENTER_ADMIN_ACCOUNT_ROUTE}/administrators`
export const SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_CREATE_ROUTE = `${SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE}/create-admin`
export const SERVICE_CENTER_ADMIN_COMMUNICATION_ROUTE = `${SERVICE_CENTER_ADMIN_ROUTE}/communication`
export const SERVICE_CENTER_MESSAGES_ROUTE = `${SERVICE_CENTER_ADMIN_COMMUNICATION_ROUTE}/messages`
export const SERVICE_CENTER_MESSAGES_CREATE_ROUTE = `${SERVICE_CENTER_MESSAGES_ROUTE}/create`
export const SERVICE_CENTER_MESSAGES_EDIT_ROUTE = `${SERVICE_CENTER_MESSAGES_ROUTE}/edit/:messageId`

export const PRESERVE_DATE_RANGE_ROUTES = [
    SURVEY_ROUTE,
    MESSAGES_ROUTE,
    SERVICE_CENTER_MESSAGES_ROUTE,
    MERCHANT_PRODUCTION_POS_PURCHASES_ROUTE,
    MERCHANT_PRODUCTION_MEETING_SERVICE_ROUTE,
    MERCHANT_PRODUCTION_TAKEAWAY_ROUTE,
]

// --- Common ---
export const ERROR_ROUTE = "/error"
export const ACCESS_DENIED_ROUTE = "/access-denied"

// Removes the prefix from the entire route
export function getAsRoute(prefix: string, route: string) {
    const logger = new Logger("router")
    const subRoute = route.substring(prefix.length + 1)
    logger.info(`Placing sub route ${subRoute} with prefix ${prefix} at: ${route}`)
    return subRoute
}

export function getReportRoute(prefix: string | undefined) {
    return `${prefix ?? ""}/${REPORT_SUB_ROUTE}`
}

export function getAdminRoute(prefix: string | undefined) {
    return `${prefix ?? ""}/${ADMIN_SUB_ROUTE}`
}

export function getAccountingRoute(prefix: string | undefined) {
    return `${prefix ?? ""}/${ACCOUNTING_SUB_ROUTE}`
}

export function getProfileRoute(prefix: string | undefined) {
    return `${prefix ?? ""}/${PROFILE_SUB_ROUTE}`
}

export function getProfileChangePasswordRoute(prefix: string | undefined) {
    return `${prefix ?? ""}/${PROFILE_CHANGE_PASSWORD_SUB_ROUTE}`
}

export function getSettingsRoute(prefix: string | undefined) {
    return `${prefix ?? ""}/${SETTINGS_SUB_ROUTE}`
}

export function getEditSurveyRoute(surveyId: number) {
    return `${MERCHANT_ADMIN_SURVEYS}/edit/${surveyId}`
}
export function getEditNewsRoute(articleId: number) {
    return `${MERCHANT_NEWS_ROUTE}/edit/${articleId}`
}

export function getEditMessageRoute(messageId: number) {
    return `${MESSAGES_ROUTE}/edit/${messageId}`
}

export function getEditTermsAndConditionRoute(termsAndConditionsId: number) {
    return `${SUPPLIER_ADMIN_TERMS_AND_CONDITIONS_ROUTE}/edit/${termsAndConditionsId}`
}

export function getEditPriceListRoute(priceListId: number) {
    return `${MERCHANT_ADMIN_PRICE_LISTS_ROUTE}/${priceListId}`
}

export function getEditProductGroupRoute(productGroupId: number) {
    return `${MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE}/${productGroupId}`
}

export function getEditVatCodesRoute(vatCodesId: number) {
    return `${MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE}/${vatCodesId}`
}

export function getEditDeliveryLocationRoute(deliveryLocationId: number) {
    return `${MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE}/${deliveryLocationId}`
}

export function getEditSalesAccountRout(salesAccountId: number) {
    return `${MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE}/edit/${salesAccountId}`
}

export function getEditSupplierMerchantRoute(merchantId: number) {
    return `${SUPPLIER_ADMIN_MERCHANTS_LIST_ROUTE}/edit/${merchantId}`
}

export function getEditSupplierProductGroupNumbersRoute(productGroupsNumbersId: number) {
    return `${SUPPLIER_ADMIN_PRODUCT_NUMBERS_ROUTE}/${productGroupsNumbersId}`
}

export function getGoPayNewsRoute(prefix: string | undefined) {
    return `${prefix ?? ""}/${NEWS_SUB_ROUTE}`
}

export function getEditDepartmentRoute(departmentId: number) {
    return `${COMPANY_ADMIN_ORGANIZATION_DEPARTMENTS_ROUTE}/edit/${departmentId}`
}

export function getEditUserGroupRoute(userGroupId: number) {
    return `${COMPANY_ADMIN_ORGANIZATION_USER_GROUPS_ROUTE}/edit/${userGroupId}`
}

export function getEditProductRoute(productId: number) {
    return `${MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE}/edit/${productId}`
}

export function getExtraServiceRoute(productId: number) {
    return `${MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE}/edit/${productId}`
}

export function getEditShopRoute(shopId: number) {
    return `${MERCHANT_ADMIN_SHOPS_LIST_ROUTE}/edit/${shopId}`
}

export function getEditPaymentLinkRout(paymentLinksId: number) {
    return `${MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE}/edit/${paymentLinksId}`
}

export function getEditSupplierTemplateRoute(templateId: number) {
    return `${SUPPLIER_ADMIN_POS_SETTINGS_ROUTE}/templates/edit/${templateId}`
}

export function getEditLocationRoute(locationId: number) {
    return `${COMPANY_ADMIN_ORGANIZATION_LOCATIONS_ROUTE}/edit/${locationId}`
}

export function getEditSchedulerJobRoute(jobUd: number) {
    return `${SUPPORT_ADMIN_HEALTH_SCHEDULER_ROUTE}/edit/${jobUd}`
}

export function getEditFeatureRoute(featureId: number) {
    return `${SUPPORT_FEATURES_ROUTE}/${featureId}`
}

export function getRefillWalletRoute(acquirerSetupId: number, walletId?: number) {
    return `${USER_REPORTS_SETTINGS_WALLETS_ROUTE}/${acquirerSetupId}/refill/${walletId}`
}

export function getEditBillReceiverRoute(billReceiverId: number) {
    return `${USER_REPORTS_SETTINGS_BILL_RECEIVERS_ROUTE}/edit/${billReceiverId}`
}

export function getQuickpayFinalizedRoute(orderUid: string) {
    return `${USER_REPORTS_ROUTE}/quickpay/finalized/${orderUid}`
}

export function getEditServiceCenterResourceRoomRoute(roomId: number) {
    return `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/room/${roomId}`
}

export function getEditServiceCenterResourceMobileAvRoute(mobileAvId: number) {
    return `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/mobile-av/${mobileAvId}`
}

export function getEditServiceCenterResourceCarsRoute(carId: number) {
    return `${SERVICE_CENTER_ADMIN_ORGANIZATION_RESOURCE_ROUTE}/cars/${carId}`
}

export function getPublicMeetingReceiptRoute(orderUid?: string) {
    return `${PUBLIC_ROUTE}/orders/meetings/${orderUid}`
}

export function getPublicReceiptRoute(orderUid: string) {
    return `${PUBLIC_ROUTE}/orders/${orderUid}`
}

export function getPublicPackageSlipReceiptRoute(slipUid?: string) {
    return `${PUBLIC_ROUTE}/meeting-service/package-slip/${slipUid}`
}

export function getDeviceEditRoute(deviceId: number) {
    return `${SERVICE_CENTER_ADMIN_ORGANIZATION_DEVICES_ROUTE}/${deviceId}`
}

export function getEditServiceCenterMessageRoute(messageId: number) {
    return `${SERVICE_CENTER_MESSAGES_ROUTE}/edit/${messageId}`
}
